import { render } from "./ConceptView.vue?vue&type=template&id=09896c92&scoped=true"
const script = {}

import "./ConceptView.vue?vue&type=style&index=0&id=09896c92&scoped=true&lang=css"

import exportComponent from "C:\\fukunocha\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09896c92"]])

export default __exports__